define('app/sdc/md/palette/classes/sdc-md-palette-classes-constant',[],function () {
	return /\bmd-(?:(?:primary|accent|warn|background)|(?:hue-\d+))\b/g;
});
